import React from 'react';
import { testimonials } from '../data/spremna';
export function Testimonials() {
  // Hidden until authentic reviews are added in data/spremna.ts (never invent testimonials)
  if (testimonials.length === 0) return null;
  return <section className="w-full border-t border-slate-900/10 bg-stone-50 px-8 py-24 sm:px-14 sm:py-32" data-id="element-269" data-mp="3fycoti6qzx8o">
      <div className="mx-auto max-w-6xl" data-id="element-270" data-mp="3b01hpf7u80u5">
        <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight text-slate-900 sm:text-6xl" data-id="element-271" data-mp="36yzgwty9vgq2">
          Шта кажу <em className="text-red-700" data-id="element-272" data-mp="31zd3okig20h9">наставници</em>
        </h2>

        <div className="mt-14 grid gap-10 border-t border-slate-900/15 pt-10 sm:grid-cols-3" data-id="element-273" data-mp="32290g5ik2j44">
          {testimonials.map(item => <figure key={item.name} className="flex h-full flex-col" data-id="element-274" data-mp="2s1ykwe91szls">
              <blockquote className="flex-1 font-serif text-2xl leading-snug text-slate-900" data-id="element-275" data-mp="2s3tai5v9lfw7">
                „{item.quote}“
              </blockquote>
              <figcaption className="mt-6 text-sm" data-id="element-276" data-mp="qa3mv1fpstm1">
                <span className="font-semibold text-slate-900" data-id="element-277" data-mp="q8ivtlslzssx">{item.name}</span>
                <span className="text-slate-900/60" data-id="element-278" data-mp="h4n5afz667d1"> — {item.location}</span>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}